import React, { useState, useEffect, useMemo } from "react";

export default function GnuAnalysisViewer({ analysisText, pr, forcedGame, onShowBestMove }) {
  const [parsed, setParsed] = useState([]);
  const [activeGame, setActiveGame] = useState(null);
const formatPr = (value) => {
  if (!value) return null;

  // если пришла строка/число — показываем как есть
  if (typeof value === 'string' || typeof value === 'number') return String(value);

  // если пришёл объект из parseGnuSummary (white/black)
  const w = value?.white?.overall ?? value?.white ?? null;
  const b = value?.black?.overall ?? value?.black ?? null;

  if (w != null || b != null) {
    const wStr = w != null ? String(w) : '—';
    const bStr = b != null ? String(b) : '—';
    return `White ${wStr} / Black ${bStr}`;
  }

  // fallback: безопасно stringify, чтобы не было [object Object]
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

// если родитель хочет принудительно показать конкретную партию (матч)
useEffect(() => {
  if (forcedGame == null) return;
  const n = Number(forcedGame);
  if (Number.isFinite(n)) setActiveGame(n);
}, [forcedGame]);

  useEffect(() => {
    // 1) Если текста нет — чистим список
    if (!analysisText || typeof analysisText !== "string") {
      setParsed([]);
      setActiveGame(null);
      return;
    }

    // 2) Нормализуем переносы строк
    const lines = analysisText.replace(/\r\n/g, "\n").split("\n");

    const parsedMoves = [];
    let current = null;
    let currentGame = 1;

    for (const rawLine of lines) {
      const line = rawLine.trimEnd();
      const t = line.trim();

      // --- Определяем GAME N (у тебя в логе есть "GAME 1")
      const gameMatch = t.match(/^GAME\s+(\d+)/i);
      if (gameMatch) {
        currentGame = parseInt(gameMatch[1], 10) || currentGame;
        continue;
      }

      // --- Ищем "Move number X"
      // делаем регекс чуть мягче (вдруг лишние пробелы/регистр)
      const moveMatch = t.match(/^Move number\s+(\d+)/i);
      if (moveMatch) {
        if (current) parsedMoves.push(current);

        const num = parseInt(moveMatch[1], 10) || 0;

        current = {
          game: currentGame,
          num,
          desc: t,
          quality: "good",
          bestMove: null,
          ts: null, // на будущее, если появится
        };
        continue;
      }

      // --- Alert: ...
      if (t.toLowerCase().includes("alert:")) {
        if (!current) continue; // ВАЖНО: если нет текущего хода — игнор

        const alertText = t.toLowerCase();
        if (alertText.includes("bad move") || alertText.includes("blunder")) {
          current.quality = "blunder";
        } else if (alertText.includes("doubtful")) {
          current.quality = "bad";
        } else if (alertText.includes("inacc")) {
          current.quality = "inaccuracy";
        } else {
          current.quality = "good";
        }
        continue;
      }

      // --- Лучшая линия обычно начинается с "1."
      if (/^1\./.test(t)) {
        if (!current) continue; // ВАЖНО
        current.bestMove = t;
        continue;
      }
    }

    if (current) parsedMoves.push(current);

    setParsed(parsedMoves);

    // выставляем активную игру по первой найденной
    const games = [...new Set(parsedMoves.map((x) => x.game))];
    if (games.length > 0) {
      setActiveGame((prev) => (prev == null ? games[0] : prev));
    } else {
      setActiveGame(null);
    }
  }, [analysisText]);

  const colorFor = (q) => {
    if (q === "blunder") return "#ff5555";
    if (q === "bad" || q === "inaccuracy") return "#ffaa00";
    return "#00cc66";
  };

  const gamesList = useMemo(() => {
    return [...new Set(parsed.map((x) => x.game))].sort((a, b) => a - b);
  }, [parsed]);

  const visible = useMemo(() => {
    if (activeGame == null) return parsed;
    return parsed.filter((x) => x.game === activeGame);
  }, [parsed, activeGame]);

  return (
    null
    // <div
    //   style={{
    //     background: "#111",
    //     borderRadius: 8,
    //     padding: 10,
    //     marginTop: 10,
    //     color: "#eee",
    //     fontFamily: "monospace",
    //     maxHeight: 300,
    //     overflowY: "auto",
    //   }}
    // >
    //   <h4 style={{ color: "#ccc", marginBottom: 8 }}>Анализ GNU</h4>

    //   {/* PR блок (показываем всегда) */}
    //   <div style={{ marginBottom: 8, color: "#bbb", fontSize: 13 }}>
    //     PR:{" "}
    //     <b style={{ color: "#eee" }}>
    //       {pr === null || pr === undefined ? "—" : String(pr)}
    //     </b>
    //   </div>

    //   {/* Переключатель GAME (если в тексте есть несколько GAME) */}
    //   {gamesList.length > 1 && (
    //     <div style={{ display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" }}>
    //       {gamesList.map((g) => (
    //         <button
    //           key={`game-btn-${g}`}
    //           onClick={() => setActiveGame(g)}
    //           style={{
    //             padding: "4px 8px",
    //             borderRadius: 6,
    //             border: "1px solid #333",
    //             background: activeGame === g ? "#222" : "transparent",
    //             color: activeGame === g ? "#fff" : "#aaa",
    //             cursor: "pointer",
    //           }}
    //         >
    //           GAME {g}
    //         </button>
    //       ))}
    //     </div>
    //   )}

    //   {/* Если парсер ничего не нашёл — покажем подсказку */}
    //   {visible.length === 0 ? (
    //     <div style={{ color: "#777", fontSize: 12 }}>
    //       Не найдено строк вида <b>Move number ...</b> в analysisText.
    //       <br />
    //       Проверь, что ты передаёшь именно вывод GNU, а не JSON/лог.
    //     </div>
    //   ) : (
    //     visible.map((m, idx) => (
    //       <div
    //         // ВАЖНО: уникальный ключ (game + num + idx)
    //         key={`${m.game}-${m.num}-${idx}`}
    //         onClick={() => onShowBestMove?.(m.bestMove)}
    //         style={{
    //           borderBottom: "1px solid #333",
    //           padding: "4px 6px",
    //           cursor: "pointer",
    //           color: colorFor(m.quality),
    //         }}
    //       >
    //         {m.desc}
    //         {m.bestMove && (
    //           <div style={{ color: "#88ff88", fontSize: 12 }}>{m.bestMove}</div>
    //         )}
    //       </div>
    //     ))
    //   )}
    // </div>
  );
}

// import React, { useState, useEffect } from 'react';

// const colorBySeverity = (line) => {
//   if (/blunder/i.test(line)) return "red";
//   if (/error/i.test(line)) return "orange";
//   if (/doubtful/i.test(line)) return "gold";
//   if (/good/i.test(line)) return "green";
//   return "white";
// };

// export default function GnuAnalysisViewer({ analysisText, onShowBestMove }) {
//   const [parsed, setParsed] = useState([]);

//   useEffect(() => {
//     if (!analysisText) return;
//     const lines = analysisText.split('\n');
//     const parsedMoves = [];
//     let current = null;

//     for (const line of lines) {
//       if (line.startsWith('Move number')) {
//         if (current) parsedMoves.push(current);
//         const num = parseInt(line.match(/Move number (\d+)/)?.[1] || '0', 10);
//         current = { num, desc: line, quality: 'good', bestMove: null };
//       } else if (line.includes('Alert:')) {
//         const alertText = line.toLowerCase();
//         if (alertText.includes('bad move') || alertText.includes('blunder')) {
//           current.quality = 'blunder';
//         } else if (alertText.includes('doubtful')) {
//           current.quality = 'bad';
//         } else if (alertText.includes('inacc')) {
//           current.quality = 'inaccuracy';
//         } else {
//           current.quality = 'good';
//         }
//       } else if (/^1\./.test(line.trim())) {
//         current.bestMove = line.trim();
//       }
//     }
//     if (current) parsedMoves.push(current);
//     setParsed(parsedMoves);
//   }, [analysisText]);

//   const colorFor = (q) => {
//     if (q === 'blunder') return '#ff5555';
//     if (q === 'bad' || q === 'inaccuracy') return '#ffaa00';
//     return '#00cc66';
//   };

//   return (
//     <div style={{
//       background: '#111',
//       borderRadius: 8,
//       padding: 10,
//       marginTop: 10,
//       color: '#eee',
//       fontFamily: 'monospace',
//       maxHeight: 300,
//       overflowY: 'auto'
//     }}>
//       <h4 style={{ color: '#ccc', marginBottom: 8 }}>Анализ GNU</h4>
//       {parsed.map((m) => (
//         <div
//           key={m.num}
//           onClick={() => onShowBestMove?.(m.bestMove)}
//           style={{
//             borderBottom: '1px solid #333',
//             padding: '4px 6px',
//             cursor: 'pointer',
//             color: colorFor(m.quality)
//           }}
//         >
//           {m.desc}
//           {m.bestMove && (
//             <div style={{ color: '#88ff88', fontSize: 12 }}>
//               {m.bestMove}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }


// import React, { useState, useEffect } from 'react';

// const colorBySeverity = (line) => {
//   if (/blunder/i.test(line)) return "red";
//   if (/error/i.test(line)) return "orange";
//   if (/doubtful/i.test(line)) return "gold";
//   if (/good/i.test(line)) return "green";
//   return "white";
// };

// export default function GnuAnalysisViewer({ analysisText, onShowBestMove }) {
//   const [parsed, setParsed] = useState([]);

//   useEffect(() => {
//     if (!analysisText) return;
//     const lines = analysisText.split('\n');
//     const parsedMoves = [];
//     let current = null;

//     for (const line of lines) {
//       if (line.startsWith('Move number')) {
//         if (current) parsedMoves.push(current);
//         const num = parseInt(line.match(/Move number (\d+)/)?.[1] || '0', 10);
//         current = { num, desc: line, quality: 'good', bestMove: null };
//       } else if (line.includes('Alert:')) {
//         const alertText = line.toLowerCase();
//         if (alertText.includes('bad move') || alertText.includes('blunder')) {
//           current.quality = 'blunder';
//         } else if (alertText.includes('doubtful')) {
//           current.quality = 'bad';
//         } else if (alertText.includes('inacc')) {
//           current.quality = 'inaccuracy';
//         } else {
//           current.quality = 'good';
//         }
//       } else if (/^1\./.test(line.trim())) {
//         current.bestMove = line.trim();
//       }
//     }
//     if (current) parsedMoves.push(current);
//     setParsed(parsedMoves);
//   }, [analysisText]);

//   const colorFor = (q) => {
//     if (q === 'blunder') return '#ff5555';
//     if (q === 'bad' || q === 'inaccuracy') return '#ffaa00';
//     return '#00cc66';
//   };

//   return (
//     <div style={{
//       background: '#111',
//       borderRadius: 8,
//       padding: 10,
//       marginTop: 10,
//       color: '#eee',
//       fontFamily: 'monospace',
//       maxHeight: 300,
//       overflowY: 'auto'
//     }}>
//       <h4 style={{ color: '#ccc', marginBottom: 8 }}>Анализ GNU</h4>
//       {parsed.map((m) => (
//         <div
//           key={m.num}
//           onClick={() => onShowBestMove?.(m.bestMove)}
//           style={{
//             borderBottom: '1px solid #333',
//             padding: '4px 6px',
//             cursor: 'pointer',
//             color: colorFor(m.quality)
//           }}
//         >
//           {m.desc}
//           {m.bestMove && (
//             <div style={{ color: '#88ff88', fontSize: 12 }}>
//               {m.bestMove}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }


// import React, { useState, useEffect } from 'react';

// const colorBySeverity = (line) => {
//   if (/blunder/i.test(line)) return "red";
//   if (/error/i.test(line)) return "orange";
//   if (/doubtful/i.test(line)) return "gold";
//   if (/good/i.test(line)) return "green";
//   return "white";
// };

// export default function GnuAnalysisViewer({ analysisText, onShowBestMove }) {
//   const [parsed, setParsed] = useState([]);

//   useEffect(() => {
//     if (!analysisText) return;
//     const lines = analysisText.split('\n');
//     const parsedMoves = [];
//     let current = null;

//     for (const line of lines) {
//       if (line.startsWith('Move number')) {
//         if (current) parsedMoves.push(current);
//         const num = parseInt(line.match(/Move number (\d+)/)?.[1] || '0', 10);
//         current = { num, desc: line, quality: 'good', bestMove: null };
//       } else if (line.includes('Alert:')) {
//         const alertText = line.toLowerCase();
//         if (alertText.includes('bad move') || alertText.includes('blunder')) {
//           current.quality = 'blunder';
//         } else if (alertText.includes('doubtful')) {
//           current.quality = 'bad';
//         } else if (alertText.includes('inacc')) {
//           current.quality = 'inaccuracy';
//         } else {
//           current.quality = 'good';
//         }
//       } else if (/^1\./.test(line.trim())) {
//         current.bestMove = line.trim();
//       }
//     }
//     if (current) parsedMoves.push(current);
//     setParsed(parsedMoves);
//   }, [analysisText]);

//   const colorFor = (q) => {
//     if (q === 'blunder') return '#ff5555';
//     if (q === 'bad' || q === 'inaccuracy') return '#ffaa00';
//     return '#00cc66';
//   };

//   return (
//     <div style={{
//       background: '#111',
//       borderRadius: 8,
//       padding: 10,
//       marginTop: 10,
//       color: '#eee',
//       fontFamily: 'monospace',
//       maxHeight: 300,
//       overflowY: 'auto'
//     }}>
//       <h4 style={{ color: '#ccc', marginBottom: 8 }}>Анализ GNU</h4>
//       {parsed.map((m) => (
//         <div
//           key={m.num}
//           onClick={() => onShowBestMove?.(m.bestMove)}
//           style={{
//             borderBottom: '1px solid #333',
//             padding: '4px 6px',
//             cursor: 'pointer',
//             color: colorFor(m.quality)
//           }}
//         >
//           {m.desc}
//           {m.bestMove && (
//             <div style={{ color: '#88ff88', fontSize: 12 }}>
//               {m.bestMove}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }
